import Button from '../../ui/Button/Button.jsx';
import styles from './CTASection.module.css';

export default function CTASection() {
  return (
    <section className={styles.section}>
      <div className="container">
        <div className={styles.panel}>
          <div className={styles.glow} aria-hidden="true" />
          <h2 className={styles.title}>Ready to show your product with confidence?</h2>
          <p className={styles.text}>
            Start from Solvora's component system and have a page ready to ship this week.
          </p>
          <div className={styles.actions}>
            <Button to="/plans" size="lg">View plans</Button>
            <Button to="/contact" variant="secondary" size="lg">Talk to us</Button>
          </div>
        </div>
      </div>
    </section>
  );
}
